import PresencasResponse from 'models/PresencasResponse';
import { createContext } from 'react';

export interface IConvocadosAssessorContext {
  presencas: PresencasResponse | null;
  atualizarPresencas: Function;
  atualizandoPresencas: boolean;
}

export default createContext<IConvocadosAssessorContext>({
  presencas: null,
  atualizarPresencas: () => {},
  atualizandoPresencas: false,
});
